import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import CloseIcon from '@mui/icons-material/Close';
import { CommunityIcon, DivisionIcon } from 'global/components/PerformIcons';
import { ListItemText, Typography } from '@mui/material';
import { get } from 'global/lib/lodash';
import {
  StyledListItem,
  ListItemHeader,
  ListItemSecondary,
  ListItemActions,
  GreyIcon,
  OrangeIcon,
  RedIcon,
  StyledAvatar,
  DatesText,
  IssueBtn,
  RowFlex,
  UpdatedCol,
} from './TaskList.styles';
import { Loading } from 'global/styles';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getRealmName } from 'global/utils';
import { Text } from 'global/components/text';
import { taskStringToNum, stopProp } from '../../../global/utils';

export default function TaskListItem(props) {
  const isHeader = get(props, 'isHeader', false);
  const isClickable = get(props, 'isClickable', true);
  const item = props.itemOverride || props.item;
  const filter = useSelector((state) => get(state, 'filter.tasks.list'));
  const DATEFORMAT = 'L';

  const [isHovered, changeIsHovered] = useState(false);
  const toggleHover = (bool) => {
    if (isHeader) {
      changeIsHovered(bool);
    }
  };

  const status = get(filter, 'status', '').toLowerCase();
  const showOpen = status.indexOf('open') > -1;
  const showPending = status.indexOf('pending') > -1;
  const showClosed = status.indexOf('closed') > -1;

  const destinationParams = get(item, 'realm.id') ? `?realmId=${get(item, 'realm.id')}` : '';
  const destination = get(props, 'destination', `/tasks/list/${get(item, 'id')}${destinationParams}`);
  const agingDate = get(item, 'oldestOpenTaskDatetime');

  const clickStatusButton = (e, stat) => {
    stopProp(e);
    props.changeFilter && props.changeFilter(stat);
  };

  const isSelected = (k) => {
    return get(props, 'filter.status') === taskStringToNum(k);
  };

  const content = {
    realmType: get(item, 'realmTier', Loading),
    label: get(item, 'label', Loading),
    realmName: getRealmName(item),
    issueOpen: get(item, 'open', Loading),
    issuePending: get(item, 'pending', Loading),
    issueClosed: get(item, 'closed', Loading),

    agingDate: agingDate ? `${moment(agingDate).format(DATEFORMAT)}` : agingDate === null ? 'N/A' : Loading,
    updatedDate: get(item, 'updatedAt') ? `${moment(get(item, 'updatedAt')).format(DATEFORMAT)}` : Loading,
  };
  content.icon = content.realmType === 'division' ? <DivisionIcon /> : content.realmType === 'community' ? <CommunityIcon /> : <HomeIcon />;
  const dayDiff = Math.abs(moment(content.agingDate).diff(moment(), 'days'));
  const TimerIcon = dayDiff > 21 ? RedIcon : dayDiff > 7 ? OrangeIcon : GreyIcon;
  content.timerIcon = TimerIcon;

  return (
    <StyledListItem
      component={isClickable ? Link : 'div'}
      to={isClickable ? destination : undefined}
      button={isClickable}
      key={item.id}
      onClick={props.onClick}
      onMouseEnter={() => {
        toggleHover(true);
      }}
      onMouseLeave={() => {
        toggleHover(false);
      }}
      isHeader={isHeader}
    >
      <StyledAvatar isHeader={isHeader}>{isHeader ? <CloseIcon /> : content.icon}</StyledAvatar>
      <ListItemText
        primary={<ListItemHeader>{content.realmName}</ListItemHeader>}
        slotProps={{ secondary: { component: 'div' } }}
        secondary={
          <ListItemSecondary isHeader={isHeader}>
            <RowFlex>
              <UpdatedCol>
                <Text type="secondarySub">Updated</Text>
                <DatesText>{content.updatedDate}</DatesText>
              </UpdatedCol>
              <UpdatedCol>
                <Text type="secondarySub">Oldest</Text>
                <DatesText>{content.agingDate}</DatesText>
              </UpdatedCol>
            </RowFlex>
          </ListItemSecondary>
        }
      />
      <ListItemActions>
        {showOpen && (
          <IssueBtn isHeader={isHeader} selected={isSelected('open')} onClick={(e) => clickStatusButton(e, 'open')}>
            <Typography variant="inherit">{content.issueOpen}</Typography>
            <Typography variant="inherit">{'OPEN'}</Typography>
          </IssueBtn>
        )}
        {showPending && (
          <IssueBtn isHeader={isHeader} selected={isSelected('pending')} onClick={(e) => clickStatusButton(e, 'pending')}>
            <Typography variant="inherit">{content.issuePending}</Typography>
            <Typography variant="inherit">{'PENDING'}</Typography>
          </IssueBtn>
        )}
        {showClosed && (
          <IssueBtn isHeader={isHeader} selected={isSelected('closed')} onClick={(e) => clickStatusButton(e, 'closed')}>
            <Typography variant="inherit">{content.issueClosed}</Typography>
            <Typography variant="inherit">{'CLOSED'}</Typography>
          </IssueBtn>
        )}
      </ListItemActions>
    </StyledListItem>
  );
}
